export default {"src":"/_next/static/media/logo-whalesync.bb276d45.svg","height":24,"width":177,"blurWidth":0,"blurHeight":0};